// This file is automatically generated. Do not edit manually.

import { FrontendUploadFileHandle } from "src/api/generated/common/frontendUploadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace WinnerImportApi {
	export async function importWinnerDesignsToCustomerOrder(args: {
		siteId: number;
		winnerExportFileHandle: FrontendUploadFileHandle;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/winner/importWinnerDesignsToCustomerOrder",
			method: "POST",
			data: {
				siteId: args.siteId,
				winnerExportFileHandle: args.winnerExportFileHandle,
			},
		});
		return response as void;
	}

	export async function importWinnerDesignsToCustomerOffer(args: {
		siteId: number;
		winnerExportFileHandle: FrontendUploadFileHandle;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/winner/importWinnerDesignsToCustomerOffer",
			method: "POST",
			data: {
				siteId: args.siteId,
				winnerExportFileHandle: args.winnerExportFileHandle,
			},
		});
		return response as void;
	}

	export async function importWinnerDesignsToProjectActivityMaterials(args: {
		projectActivityId: number;
		winnerExportFileHandle: FrontendUploadFileHandle;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/winner/importWinnerDesignsToProjectActivityMaterials",
			method: "POST",
			data: {
				projectActivityId: args.projectActivityId,
				winnerExportFileHandle: args.winnerExportFileHandle,
			},
		});
		return response as void;
	}
}
